(function() {
   /* 
    * Page View
    *
    * @listens BLOXEEditionPageViewed
    * @fires dataLayer#Page View
    */
    window.addEventListener('BLOXEEditionPageViewed', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'properties': {
                    'segmented': ev.detail.segmented,
                    'zoom_level': ev.detail.zoom_level,
                    'display_fit': ev.detail.display_fit
                }
            });
        }
    });
   /* 
    * E-Edition Page Navigation Initiated
    *
    * @listens BLOXEEditionPageNavigationInitiated
    * @fires dataLayer#E-Edition Page Navigation Initiated
    */
    window.addEventListener('BLOXEEditionPageNavigationInitiated', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'E-Edition Page Navigation Initiated',
                'properties': {
                    'navigation_method': ev.detail.navigation_method,
                    'navigation_subsection': ev.detail.navigation_subsection
                }
            });
        }
    });
   /* 
    * E-Edition Segment Asset Viewed
    *
    * @listens BLOXEEditionSegmentAssetView
    * @fires dataLayer#E-Edition Segment Asset Viewed
    */
    window.addEventListener('BLOXEEditionSegmentAssetView', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'E-Edition Segment Asset Viewed',
                'properties': {
                    'segment_asset_id': ev.detail.segment_asset_id,
                    'segment_asset_name': ev.detail.segment_asset_name,
                    'segment_asset_url': ev.detail.segment_asset_url,
                    'segment_asset_page_number': ev.detail.segment_asset_page_number
                }
            });
        }
    });
   /* 
    * E-Edition Display Fit Selected
    *
    * @listens BLOXEEditionDisplayFitSelected
    * @fires dataLayer#E-Edition Display Fit Selected
    */
    window.addEventListener('BLOXEEditionDisplayFitSelected', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'E-Edition Display Fit Selected',
                'properties': {
                    'selected_fit': ev.detail.selected_fit,
                    'selected_num_of_pages': ev.detail.selected_num_of_pages,
                    'is_fullscreen': ev.detail.is_fullscreen,
                    'is_cover': ev.detail.is_cover
                }
            });
        }
    });
   /* 
    * E-Edition Zoom Level Modified
    *
    * @listens BLOXEEditionZoomLevelModified
    * @fires dataLayer#E-Edition Zoom Level Modified
    */
    window.addEventListener('BLOXEEditionZoomLevelModified', function(ev) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'E-Edition Zoom Level Modified',
                'properties': {
                    'zoom_method': ev.detail.zoom_method,
                    'zoom_level': ev.detail.zoom_level
                }
            });
        }
    });
})();